module.exports = __webpack_public_path__ + "static/media/icon-teams-roles-checked.447802d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teams-roles-checked.svg
// module id = 1857
// module chunks = 0